import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71d58740"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "column",
  style: {"gap":"8px"}
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col no-padding bg-grey" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-2 q-pr-xs" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" < ")
const _hoisted_8 = { class: "col-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Login.LoginSection.EmailUsername')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_input, {
          dense: "",
          borderless: "",
          modelValue: _ctx.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          debounce: "500",
          color: "green",
          class: "col no-padding"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_btn, {
          type: "submit",
          class: "bg-secondary text-white",
          style: {"width":"100%"},
          onClick: _ctx.toggleForgotRegister,
          to: "home"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_q_btn, {
          type: "submit",
          class: "bg-secondary text-white",
          style: {"width":"100%"},
          onClick: _ctx.tryForgot,
          to: "home"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Login.LoginSection.ResetPassword")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}